export type SendEmailCodeResponse = {
  success: boolean;
  data?: {
    cypher: string;
  };
  message: string;
};

export type ValidationEmailCodeResponse = {
  success: boolean;
  data: string;
  message: string;
};

export type ValidationEmailCodeParams = {
  cypher: string;
  codeEmail: string;
  actionType: string;
};

export enum ChangePasswordErrorCode {
  WrongOTP = "wrong_OTP",
  WrongPassword = "wrong_password",
  AlreadyUsed = "already_used"
}

export type ChangePasswordParams = {
  old_password: string;
  password: string;
};

export type ChangePasswordResponse = {
  success: boolean;
  errorCode?: ChangePasswordErrorCode;
  message?: string;
  jwt?: string;
};

export type Setup2faResponse = {
  qrContent: string;
  secret: string;
};

export type TryConnectionParams = {
  email: string;
  password: string;
  codeOtp: string;
};

export type TryConnectionResponse = {
  success: boolean;
  data: {
    action: string;
    id: string;
  };
};

export type ActivateF2aParams = { otp: string; secret: string };

export type AddTraceResponse = {
  action: string;
  id: string;
};

export type UpdateTraceResponse = {
  action: string;
  id: string;
};

export type UpdateTraceParams = {
  id: number;
  success: boolean;
  web_authn_signing_action_id?: string | null;
  user_otp_input?: string | null;
};

export type SensitiveEmail = {
  email: string;
  actionType?: string;
  actionData?: string;
};

export type SendSensitiveEmailCodeResponse = {
  success: boolean;
  data?: {
    uuid: string;
  };
  message: string;
};

export type ValidationSensitiveEmailCodeParams = {
  uuidSensitiveActionValidation: string;
  code: string;
  actionType: string;
};

export type ValidationSensitiveEmailCodeResponse = {
  success: boolean;
  data?: {
    is_validated: boolean;
  };
  message: string;
};
